import httpService from './httpService'
import SessionService from './sessionService'

async function register(user) {
  return httpService.apiRequest('post', '/profile/agentRegister', user)
}

async function registerUser(user) {
  return httpService.apiRequest(
    'post',
    `/profile/${SessionService.getUserUsername()}/agentRegister/user`,
    user,
  )
}

async function getAgents() {
  return httpService.apiRequest('get', `/user/${SessionService.getUserUsername()}/list/agents`)
}

async function getAgentUsers(data) {
  return httpService.apiRequest(
    'post',
    `/user/${SessionService.getUserUsername()}/list/agents/users`,
    data,
  )
}

async function getAgentOrganizations() {
  return httpService.apiRequest(
    'get',
    `/user/${SessionService.getUserUsername()}/list/agents/organizations`,
  )
}

async function acceptOrReject(data) {
  return httpService.apiRequest(
    'post',
    `/user/${SessionService.getUserUsername()}/agent/acceptOrReject`,
    data,
  )
}

async function addCommission(data) {
  return httpService.apiRequest(
    'post',
    `/user/${SessionService.getUserUsername()}/agent/addCommission`,
    data,
  )
}

async function getAgentCode() {
  return httpService.apiRequest('get', `/user/${SessionService.getUserUsername()}/agent/code`)
}

async function getCommissionStatements({ period } = {}) {
  return httpService.apiRequest(
    'get',
    `/user/${SessionService.getUserUsername()}/commissionStatements${
      period ? `?period=${period}` : ''
    }`,
  )
}

async function generateCommissionStatements(data) {
  return httpService.apiRequest(
    'post',
    `/user/${SessionService.getUserUsername()}/commissionStatements/generate`,
    data,
  )
}

async function approveCommissionStatement(statementId) {
  return httpService.apiRequest(
    'post',
    `/user/${SessionService.getUserUsername()}/commissionStatements/${statementId}/approve`,
  )
}

async function markCommissionStatementPaid(statementId) {
  return httpService.apiRequest(
    'post',
    `/user/${SessionService.getUserUsername()}/commissionStatements/${statementId}/paid`,
  )
}

async function getAgentCommissionStatements() {
  return httpService.apiRequest(
    'get',
    `/user/${SessionService.getUserUsername()}/agent/commissionStatements`,
  )
}

async function downloadFile(data) {
  return httpService.apiRequest(
    'post',
    `/user/${SessionService.getUserUsername()}/agent/downloadFile`,
    data,
  )
}

export default {
  register,
  getAgentCode,
  getCommissionStatements,
  generateCommissionStatements,
  approveCommissionStatement,
  markCommissionStatementPaid,
  getAgentCommissionStatements,
  getAgents,
  acceptOrReject,
  registerUser,
  getAgentUsers,
  getAgentOrganizations,
  addCommission,
  downloadFile,
}
